export default {
  aggregates: {
    aggregated: 'Aggregerte resultater',
    aggregatedDate: '{startDate}–{fromDate}',
    ago: 'siden',
    from: 'fra',
    since: 'siden',
    unit: {
      DAY: 'dag|dager',
      MONTH: 'måned|måneder',
      YEAR: 'år|år'
    },
    untilNow: 'til nå'
  },
  categoryDetails: {
    average: 'Gjennomsnitt:',
    chartLabel: {
      noLabel: 'Nei',
      yesLabel: 'Ja'
    },
    description:
      'Dette viser hvordan teamets svar på alle spørsmålene i kategorien er fordelt.',
    hideOwnAnswers: 'Skjul egne svar',
    noResponses: 'Ingen svar',
    notParticipating: 'Du har ikke svart på disse spørsmålene selv.',
    numberOfPeople: 'Deltakere:',
    sensitiveQuestion: 'Kun tilgjengelig for deg som leder.',
    showFollowUpQuestions: 'Vis oppfølgingsspørsmål',
    toggleButton: {
      overview: 'Overblikk',
      questions: 'Spørsmål'
    },
    tooltip: {
      barValue: 'ingen | {count} person | {count} personer',
      barValueAnswers: 'ingen | {count} svar | {count} svar'
    },
    workWith: 'Forbedre {categoryName}',
    yourResponse: 'Du svarte:'
  },
  error: {
    couldNotLoadAggregates: 'Kunne ikke laste aggregerte resultater.',
    couldNotLoadResults: 'Kunne ikke laste resultater.',
    networkError:
      'Det oppstod et problem ved lasting av data fra Internett. Har du en fungerende forbindelse?',
    unknown: 'Det er en ukjent feil'
  },
  errors: {
    status: {
      BadRequest: 'Ugyldig forespørsel til server',
      Forbidden: 'Det er ikke tillatt å få tilgang til denne ressursen.',
      InternalServerError:
        'Noe gikk galt på serveren, vennligst kontakt support hvis feilen vedvarer',
      NotFound: 'Kan ikke finne det du ser etter',
      Unauthorized: 'Du er ikke autorisert for tilgang til denne ressursen',
      UnknownError: 'Ukjent feil oppstod'
    }
  },
  freetext: {
    loadResponses: 'Last opp svar',
    noFreeTextQuestions:
      'Når du har fritekstspørsmål i undersøkelsen, vil du kunne se alle svarene her.',
    notEnoughResponses: 'Ikke nok svar.',
    responses: 'Ingen svar|{count} svar | {count} svar'
  },
  general: {
    add: 'Legg til',
    cancel: 'Avbryt',
    entireOrganization: 'Hele organisasjonen',
    ok: 'Ok'
  },
  groupsComparison: {
    averageForItem:
      '{value} er den gjennomsnittlige verdien for spørsmål innen {title}. {compareToBenchmark}',
    currentValue: 'Gjeldende verdi',
    filter: {
      findGroups: 'Finn grupper',
      shouldExportWithHierarchy: 'Inkluder underliggende grupper'
    },
    loadMore: 'Last inn mer',
    loadMoreInGroup: 'Last opp mer under {groupName}',
    noone: 'Ingen har svart',
    noResults:
      'Det er ikke nok svar for denne gruppen enda. {numberOfUsersThatHaveRespondedText}.',
    noResultsResponded: 'har svart',
    nps: 'Net Promoter Score',
    nps_detractors: 'Negative bidragsytere',
    nps_passives: 'Passive',
    nps_promoters: 'Promotører',
    questions: 'Spørsmål i kategori',
    showTrend: 'Vis endring',
    violationsIn:
      'Det har blitt rapportert at det har forekommet brudd i {groupName}. Kontakt HR-avdelingen som kan fortelle deg mer og hjelpe deg med å håndtere problemet fremover.'
  },
  history: {
    selectorDescriptions: {
      noCustomDateSelected: 'Velg en dato som startpunkt for historikken.',
      selectDate: 'Vil du vise undersøkelseshistorikken fra {date}.',
      selectedDate: 'Viser undersøkelseshistorikken fra {date}.'
    },
    selectorOptions: {
      custom: 'tilpasset',
      oneMonth: '1 min',
      oneYear: '12 min',
      sixMonths: '6 min'
    }
  },
  loading: {
    error: {
      link: 'Prøv igjen'
    }
  },
  navbar: {
    administration: 'Admin',
    currentSurveys: 'Pågående spørreundersøkelser',
    help: 'Hjelp',
    myActivities: 'Handlinger',
    ourResults: 'Resultater',
    overview: 'Oversikt',
    team: 'Team',
    welcome: 'Velkommen'
  },
  page: {
    results: 'Alle resultater'
  },
  resultDetails: {
    backToResults: 'Gå tilbake',
    exportData: 'Eksporter',
    exportModal: {
      includeSensitiveQuestions: 'Inkluder sensitive spørsmål',
      loadingMessage: 'Forbereder data for eksportering. Vent litt!',
      saveAsExcelAllGroupsDescription:
        'Ved å eksportere til Excel vil du få en fil med resultater for {groupTitle} og alle underliggende grupper. Dette er bra hvis du ønsker å utføre din egen multigruppeanalyse eller -utregning.',
      saveAsExcelButton: 'Excel',
      saveAsExcelDescription:
        'Ved å eksportere til Excel vil du få en fil med resultater for {groupTitle}{segmentInfo}. Dette er bra hvis du ønsker å utføre din egen analyse eller utregning.',
      saveAsPdfButton: 'PDF',
      saveAsPdfDescription:
        'Du vil nå få et PDF-dokument med resultater for alle kategorier og spørsmål for den valgte gruppen. Nyttig hvis du ønsker å skrive ut resultatene.',
      saveAsPowerPointButton: 'PowerPoint',
      saveAsPowerPointDescription:
        'Ved å eksportere til Powerpoint vil du få en fin presentasjon av resultatene for {groupTitle}{segmentInfo}. Perfekt når du har behov for å vise resultatene til andre på en stor skjerm.'
    },
    notes: {
      draggable: {
        explanation: 'Kun synlig for deg',
        placeholder:
          'Skriv dine egne notater, kommentarer og refleksjoner om undersøkelsen her',
        title: 'Personlige notater'
      },
      status: {
        initial: 'Lagrer automatisk mens du skriver',
        saved: 'Endringer lagret!',
        unsaved: 'Lagrer snart...'
      }
    },
    tagDetails: {
      color: {
        alerts: {
          notEnoughResponses:
            'Det er for få svar til å vise resultater per bruker'
        },
        description: {
          high: 'Svaret fra en person førte til at gjennomsnitsskåren ble grønn. | Det er {count} personer som svarte slik at gjennomsnittsskåren deres ble grønn.',
          low: 'Svaret fra en person førte til at gjennomsnittsskåren ble rød. Det er {count} personer som svarte slik at gjennomsnittsskåren deres ble rød.',
          medium:
            'Svaret fra en person førte til at gjennomsnittskåren ble gul.| Det er {count} personer som svarte slik at gjennomsnittsskåren deres ble gul.'
        },
        title: 'Ingen |Én person|{count} personer'
      },
      currentValue: {
        equalsToBenchmarkValue:
          'Poengsummen din er den samme som Pulsᐩ benchmark® for {title}.',
        higherThanBenchmarkValue:
          'Poengsummen din er {benchmarkDiff} høyere enn Pulsᐩ benchmark® for {title}, som er {benchmarkValue}. Bra!',
        lowerThanBenchmarkValue:
          'Du er {benchmarkDiff} lavere enn Pulsᐩ benchmark® for {title}, som er {benchmarkValue}',
        percentagePoints: 'prosentpoeng'
      },
      enps: {
        button: {
          description:
            'Du blir sendt til partneren vår, EQI, som samler referansepunktdata fra et stort antall organisasjoner og gir mer detaljert innsikt i din egen eNPS-poengsum.',
          title: 'Sammenlign din eNPS-poengsum med andre organisasjoner'
        }
      },
      toggleButton: {
        history: 'Historikk',
        overview: 'Oversikt'
      }
    }
  },
  results: {
    aggregated: 'Aggregert',
    chooseSurvey: 'Velg spørreundersøkelse',
    finished: 'Ferdig',
    published: 'Pågående'
  },
  resultsmessages: {
    disclaimer: 'Pulsᐩ AI bruker generativ KI og kan gjøre feil.',
    error: {
      generic:
        'Ojda ... noe fungerer ikke som forventet. Vennligst forsøk å laste opp siden på nytt.',
      notEnoughResults:
        'Ingen resultater å snakke om. Vennligst velg en annen gruppe eller spørreundersøkelse for å bruke Pulsᐩ AI.'
    },
    moreInfo: 'Lær hvordan du som leder kan bruke Pulsᐩ',
    moreInfoLink: 'https://www.puls-solutions.com/help/#/section/1/articles/10',
    placeholder: 'Still et spørsmål om resultatene ...',
    reload: 'Last opp siden på nytt',
    report: 'Rapporter problemet',
    send: 'Send',
    suggestionHeader: 'Her er noen forslag til spørsmål du kan stille.',
    suggestions: {
      groupsComparison: {
        1: 'Hvilke grupper bør jeg fokusere på?',
        2: 'Er det noen spørsmål som de fleste grupper bør jobbe med?',
        3: 'Hvilke grupper viser negative trender?',
        4: 'Hvilke grupper har positive trender?',
        5: 'Hvilke grupper skiller seg ut negativt?',
        6: 'Hvilke grupper trenger min oppmerksomhet?',
        7: 'Hva skal jeg gjøre først?'
      },
      overview: {
        1: 'Hva skal jeg gjøre med resultatet vårt?',
        2: 'Hvordan skal jeg presentere resultatet for teamet mitt?',
        3: 'Hvordan ser resultatene ut totalt sett?',
        4: 'Hva er de tre viktigste tiltakene vi bør iverksette?',
        5: 'Hva kan jeg forbedre i mitt lederskap?',
        6: 'Hvilke risikoer har vi?',
        7: 'Hva kan skje hvis vi ikke handler?',
        8: 'Hva bør jeg prioritere?',
        9: 'Hva er prognosen for teamet mitt?'
      }
    },
    title: 'Pulsᐩ AI'
  },
  resultsPerAttribute: {
    attributes: {
      all: {
        title: 'Alle'
      }
    }
  },
  sections: {
    resultsForSurvey: {
      tabs: {
        compare: {
          title: 'Sammenlign'
        },
        export: {
          title: 'Eksporter'
        },
        freetext: {
          title: 'Fritekst'
        },
        results: {
          title: 'Spørreundersøkelsesresultater'
        }
      }
    }
  },
  segmentedDetails: {
    notEnoughResponses:
      'Det er ikke mulig å vise statistikk uten å risikere anonymiteten.',
    others: 'Annet | Andre',
    tooltip: {
      barValue: '{numberOfPeople} {segment}'
    }
  },
  sidebar: {
    administration: 'Administrasjon',
    currentSurveys: 'Gjeldende undersøkelser',
    dashboard: 'Instrumentbord',
    help: 'Hjelp',
    logOut: 'Logg av',
    myActivities: 'Mine oppgaver',
    ourResults: 'Våre resultater'
  },
  topbanner: {
    preview: {
      body: 'Du ser nå på den nye versjonen av Pulsᐩ-resultater med mange forbedringer! Hvis du støter på noe som ikke fungerer som det skal eller har en tilbakemelding, vær så snill å gi oss beskjed! Du kan også gå tilbake til den gamle versjonen, om du ønsker det.',
      header: 'Ny versjon!'
    }
  },
  trendArrow: {
    category: {
      tooltip: {
        trend_decreased:
          'I løpet av tidsperioden {startDate} - {endDate} har resultatet blitt redusert for {categoryName}.',
        trend_increased:
          'I løpet av tidsperioden {startDate} - {endDate} har resultatet økt for {categoryName}. Fortsett det gode arbeidet!',
        trend_same:
          'Resultatet har vært det samme for {categoryName} i tidsperioden {startDate} - {endDate}.'
      }
    },
    noTrend: 'Det er ingen eldre undersøkelse å sammenligne med.',
    tag: {
      tooltip: {
        nps_trend_decreased:
          'Sammenlignet med forrige undersøkelse den {oldSurveyDate}, har resultatet sunket med {changeInPercent} % for {tagName}.',
        nps_trend_increased:
          'Sammenlignet med forrige undersøkelse den {oldSurveyDate}, har resultatet økt med {changeInPercent} % for {tagName}.',
        nps_trend_same:
          'Resultatet har forblitt omtrent det samme ({changeInPercent} % endring) for {tagName} siden forrige undersøkelse den {oldSurveyDate}.',
        trend_decreased:
          'I løpet av tidsperioden {startDate} - {endDate} har resultatet blitt redusert for {tagName}.',
        trend_increased:
          'I løpet av tidsperioden {startDate} - {endDate} har resultatet økt for {tagName}',
        trend_same:
          'Resultatet har vært det samme for {categoryName} i tidsperioden {startDate} - {endDate}.'
      }
    }
  },
  utilityBar: {
    allGroups: 'Alle grupper',
    cannotChangeGroupsWhileComparing:
      'I sammenligningsvisning ser du på flere grupper samtidig.',
    group: 'Gruppe',
    segment: 'Segment',
    survey: 'Spørreundersøkelse'
  },
  widgetActionsSummary: {
    labels: {
      peopleThatSelectedAnAction:
        'Antall personer som valgte minst en handling',
      totalActions: 'Totalt antall aktiviteter valgt'
    },
    title: 'Oppsummering av handlinger'
  },
  widgetAlert: {
    actions: {
      saved: 'Takk, aktiviteten ble lagret.'
    },
    links: {
      tooltip: 'Koblingen åpner et nytt vindu.'
    },
    notEnoughData: 'Det er ingenting å vise her akkurat nå.'
  },
  widgetCategoriesBars: {
    aggregateInfo: {
      harassment: {
        info: 'De siste rapporterte {surveyDate}.'
      },
      question: {
        info: 'De siste forespurte {surveyDate} i "{surveyTitle}".'
      }
    },
    notEnoughResponses: 'Det er ikke nok svar enda til å vise noe her.',
    title: 'Kategorier',
    tooltip: {
      value:
        'Dette er gjennomsnittsverdien for alle svar på spørsmålene i {categoryName}, som er besvart av folk i {groupName}.'
    }
  },
  widgetErrorFallback: {
    description:
      'En uventet feil oppstod da widgeten forsøkte å laste opp. Først kan du forsøke å laste opp siden på nytt. Hvis problemet vedvarer, vennligst rapporter problemet til oss og vi vil umiddelbart se på det.',
    hideErrorDetails: 'Skjul feildetaljer',
    showErrorDetails: 'Vis feildetaljer',
    title: 'Problem med widget!'
  },
  widgetGroupActions: {
    allCategories: 'I alle kategorier',
    freeText: {
      alert: {
        noResults: 'Ingenting funnet. Prøv å skrive noe annet.',
        typeMore: 'Skriv litt mer'
      },
      filterField: {
        placeholder: 'Skriv for å finne kommentarer'
      },
      numberOfComments: '{numberOfComments} kommentarer'
    },
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887258169',
        title: 'Hvordan utvikle personlig ansvar blant ansatte'
      }
    },
    noActions: 'Ingen oppgaver å vise.',
    noActionsSelectedInCategory: 'Ingen handlinger er valgt',
    otherActions: 'Egne oppgaver',
    people: 'ingen | {count} person | {count} personer',
    peopleSelectedActions:
      'Av {peopleResponded} personer som svarte, valgte bare 1 minst én handling ({percentage} %)| Av {peopleResponded} personer som svarte, valgte {count} personer minst én handling ({percentage} %)',
    title: 'Valge oppgaver for folk i {groupName}',
    tooltip: {
      numberOfPeopleChoseActions:
        '1 person valgte denne handlingen| {count} personer valgte denne handlingen'
    }
  },
  widgetGroupPriorities: {
    description:
      'Ifølge undersøkelsens deltakere er dette de viktigste fokusområdene akkurat nå.',
    freeTextResponses: 'Vis svar med fritekst',
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887214144',
        title: 'Slik utvikler du teamet ditt med Pulsᐩ'
      }
    },
    noPriorities: 'Ingen av deltakerne har valgt noen prioriteringer.',
    people: 'ingen | {count} person | {count} personer',
    thinkImportant: ' syns «{category}» er viktigst',
    title: 'Prioriteringer for folk i {groupName}'
  },
  widgetNotImplemented: {
    content: 'Ikke implementert enda'
  },
  widgetSurveyInfo: {
    endDate: 'Sluttdato:',
    noone: 'Ingen har svart',
    notEnoughResponses: {
      aggregate:
        'Det var ikke mange nok som svarte innenfor tidsperioden til å kunne vise resultater.',
      completed:
        'Det var ikke mange nok som svarte på undersøkelsen til å kunne vise resultater.',
      published:
        'Det er ennå ikke mange nok som har svart på undersøkelsen til å kunne vise resultater.'
    },
    participation: {
      title: 'Deltakelse'
    },
    startDate: 'Startdato:',
    status: {
      completed: 'Undersøkelsen er fullført! Dette er de endelige resultatene.',
      published: 'Undersøkelsen pågår enda. Resultatene er foreløpige.'
    },
    usersInvited: 'Folk inviterte:',
    usersResponded: 'Folk svarte:'
  },
  widgetTagsDonuts: {
    description: {
      all: 'Dette er de siste resultatene for {groupName}.'
    },
    notEnoughResponses: 'Det er ikke nok svar enda til å vise noe her.',
    title: {
      company: 'Hele {organizationName}'
    },
    tooltip: {
      enps_description:
        'eNPS står for Employee Net Promoter Score og måler sannsynligheten for hvor villig de ansatte er til å anbefale sin arbeidsgiver til en venn eller bekjent.',
      nps_description:
        'NPS står for Net Promoter Score og er et mål for hvor sannsynlig det er at folk anbefaler noe til andre.',
      nps_detractors: 'Negative bidragsytere',
      nps_passives: 'Passive',
      nps_promoters: 'Promotører',
      value:
        'Dette er gjennomsnittsverdien for alle svarene på spørsmålene merket med {tagName}, som er besvart av folk i {groupName}.'
    }
  },
  widgetTagsTrends: {
    title: '{tagNames} over tid',
    twoTags: '{tag1} og {tag2}'
  }
}
